// extracted by mini-css-extract-plugin
export default {"table_container":"DashboardDrafts_table_container__3Xhcz","table_textField":"DashboardDrafts_table_textField__4ps5l","actions_container":"DashboardDrafts_actions_container__RIMwC"};